module.exports = __webpack_public_path__ + "img/banner04.f4ae12e0.png";